module.exports = __webpack_public_path__ + "img/categorie-nos-points-de-vente-famille-boutrais.df1edfd9.jpg";